import Reveal from "@/components/Reveal";

/** Interactive five-stage project guide. Selections feed the enquiry form. */
const StageGuide = ({ content, selectedStage, onSelectStage, onEnquire }) => (
  <div>
    <Reveal>
      <h2 className="font-serif text-3xl md:text-4xl tracking-tight leading-snug text-charcoal" data-testid="stage-guide-heading">
        {content.heading}
      </h2>
      <p className="mt-4 text-base leading-relaxed text-charcoal/85 max-w-2xl">{content.intro}</p>
    </Reveal>

    <div className="mt-8 flex flex-wrap gap-3" role="group" aria-label="Project stages" data-testid="stage-selector">
      {content.stages.map((stage, i) => (
        <button
          key={stage.id}
          type="button"
          aria-pressed={selectedStage === stage.id}
          data-testid={`stage-button-${stage.id}`}
          onClick={() => onSelectStage(stage.id)}
          className={`px-4 py-3 rounded-sm border text-sm text-left transition-colors duration-300 ${
            selectedStage === stage.id
              ? "bg-eucalyptus text-cream border-eucalyptus"
              : "bg-cream text-charcoal border-charcoal/25 hover:border-ochre hover:text-ochre-dark"
          }`}
        >
          <span className="font-serif block text-base">
            {i + 1}. {stage.label}
          </span>
          <span className={`block mt-1 text-xs ${selectedStage === stage.id ? "text-cream/80" : "text-charcoal/60"}`}>
            {stage.summary}
          </span>
        </button>
      ))}
    </div>

    {selectedStage && (
      <div className="mt-8 border border-charcoal/15 bg-cream p-7 md:p-10" data-testid="stage-results">
        <p className="text-xs uppercase tracking-[0.15em] text-ochre-dark" data-testid="stage-results-label">
          {content.resultsLabel}
        </p>
        {(selectedStage === "exploring" || selectedStage === "organising") && (
          <p className="mt-4 text-sm text-charcoal/80 border-l-2 border-ochre pl-4" data-testid="stage-early-note">
            {content.earlyNote}
          </p>
        )}
        {(() => {
          const stage = content.stages.find((s) => s.id === selectedStage);
          return (
            <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-8">
              <div>
                <h3 className="font-serif text-lg text-charcoal">Main questions to address</h3>
                <ul className="mt-3 space-y-2 text-sm leading-relaxed text-charcoal/85 list-disc pl-5" data-testid="stage-questions">
                  {stage.questions.map((q) => <li key={q}>{q}</li>)}
                </ul>
              </div>
              <div>
                <h3 className="font-serif text-lg text-charcoal">Documents worth preparing</h3>
                <ul className="mt-3 space-y-2 text-sm leading-relaxed text-charcoal/85 list-disc pl-5" data-testid="stage-documents">
                  {stage.documents.map((d) => <li key={d}>{d}</li>)}
                </ul>
              </div>
              <div>
                <h3 className="font-serif text-lg text-charcoal">Funding categories to investigate</h3>
                <ul className="mt-3 space-y-2 text-sm leading-relaxed text-charcoal/85 list-disc pl-5" data-testid="stage-funding">
                  {stage.funding.map((f) => <li key={f}>{f}</li>)}
                </ul>
              </div>
            </div>
          );
        })()}
        <button
          type="button"
          data-testid="stage-enquiry-button"
          onClick={() => onEnquire(selectedStage)}
          className="mt-8 bg-eucalyptus text-cream px-6 py-3 rounded-sm text-sm tracking-wide hover:bg-eucalyptus-deep transition-colors duration-300"
        >
          {content.stages.find((s) => s.id === selectedStage)?.button}
        </button>
      </div>
    )}
  </div>
);

export default StageGuide;
